import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import icon2 from "../../images/icon/m_01.svg";
import icon4 from "../../images/icon/m_03.svg";
import icon5 from "../../images/icon/m_04.svg";
import icon8 from "../../images/icon/m_08.svg";
import logo from "../../images/logo/logo-main.png";
import { Users } from "lucide-react";

const Header2 = (props) => {
  const [selectedService, setSelectedService] = useState("aws");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openMobileSubmenus, setOpenMobileSubmenus] = useState({});
  const [isSticky, setSticky] = useState(false);
  const location = useLocation();

  // Keep your behavior: scroll to top on route change and close stuff
  useEffect(() => {
    window.scrollTo(10, 0);
    setSidebarOpen(false);
    setOpenMobileSubmenus({});
  }, [location.pathname]);

  const handleNavLinkClick = () => {
    setSidebarOpen(false);
    setOpenMobileSubmenus({});
    window.scrollTo(10, 0);
  };

  const toggleMobileSubmenu = (menuName, e) => {
    e.preventDefault();
    setOpenMobileSubmenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleServiceClick = (service) => setSelectedService(service);

  // Keep your sticky logic (no design change)
  useEffect(() => {
    const onScroll = () => setSticky(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock page scroll ONLY while sidebar is open; guaranteed cleanup.
  useEffect(() => {
    const body = document.body;
    if (sidebarOpen) {
      const scrollY = window.scrollY;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      body.dataset.scrollY = String(scrollY);
    } else {
      const y = parseInt(body.dataset.scrollY || "0", 10);
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      delete body.dataset.scrollY;
      window.scrollTo(0, y);
    }
    return () => {
      // safety cleanup in case of fast unmount
      const y = parseInt(document.body.dataset.scrollY || "0", 10);
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      delete document.body.dataset.scrollY;
      if (sidebarOpen) window.scrollTo(0, y);
    };
  }, [sidebarOpen]);

  // ——— Sidebar markup unchanged (same classes/design) ———
  const Sidebar = (
    <div className={`mobile-sidebar-menu ${sidebarOpen ? "active" : ""}`}>
      <div className="overlay" onClick={() => setSidebarOpen(false)}></div>
      <div className="sidebar-inner">
        <div className="sidebar-header">
          <div className="header-logo">
            <Link onClick={handleNavLinkClick} to="/" className="logo01">
              <img
                src={logo}
                style={{ width: "100%", maxWidth: "100px" }}
                alt="SPIOT Systems Private Limited Logo"
              />
            </Link>
          </div>
          <div className="close-btn" onClick={() => setSidebarOpen(false)}>
            <i className="far fa-times"></i>
          </div>
        </div>
         {/* <Link
                onClick={handleNavLinkClick}
                to="/contact"
                className="thm-btn thm-btn--header btn-effect_1 d-block header-contact-mobile-btn"
              >
                Let's talk
                <span>
                  <svg
                    width="27"
                    height="23"
                    viewBox="0 0 27 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.9036 0H8.09835C3.6325 0 0 3.63251 0 8.09835V10.2235C0 14.6883 3.6325 18.3208 8.09738 18.3208H8.41206L7.88759 21.1734C7.806 21.6202 8.0022 22.065 8.38876 22.3059C8.56844 22.4176 8.76852 22.473 8.96957 22.473C9.20073 22.473 9.43091 22.3992 9.62614 22.2535L14.8884 18.3218H18.9026C23.3675 18.3218 27 14.6893 27 10.2244V8.09835C27.001 3.63251 23.3685 0 18.9036 0ZM25.2527 10.2225C25.2527 13.7239 22.404 16.5726 18.9026 16.5726H14.598C14.4096 16.5726 14.226 16.6338 14.0745 16.7464L9.90683 19.8603L10.3216 17.6041C10.3682 17.3486 10.2992 17.0864 10.1331 16.8863C9.96705 16.6872 9.72132 16.5716 9.462 16.5716H8.09738C4.59599 16.5716 1.74729 13.7229 1.74729 10.2215V8.09835C1.74729 4.59696 4.59599 1.74826 8.09738 1.74826H18.9026C22.404 1.74826 25.2527 4.59696 25.2527 8.09835V10.2225Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M8.39173 7.75342C7.61473 7.75342 6.98535 8.38279 6.98535 9.15980C6.98535 9.93681 7.61473 10.5662 8.39173 10.5662C9.16874 10.5662 9.79811 9.93681 9.79811 9.15980C9.79714 8.38279 9.16777 7.75342 8.39173 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M13.5006 7.75342C12.7236 7.75342 12.0942 8.38279 12.0942 9.15980C12.0942 9.93681 12.7236 10.5662 13.5006 10.5662C14.2776 10.5662 14.907 9.93681 14.907 9.15980C14.907 8.38279 14.2776 7.75342 13.5006 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M18.6095 7.75342C17.8325 7.75342 17.2031 8.38279 17.2031 9.15980C17.2031 9.93681 17.8325 10.5662 18.6095 10.5662C19.3865 10.5662 20.0159 9.93681 20.0159 9.15980C20.0159 8.38279 19.3865 7.75342 18.6095 7.75342Z"
                      fill="#D44A00"
                    />
                  </svg>
                </span>
              </Link> */}
        <div className="sidebar-menu">
          <ul>
            <li>
              <Link onClick={handleNavLinkClick} to="/">
                Home
              </Link>
            </li>

            <li
              className={`menu-item-has-children ${
                openMobileSubmenus["Company"] ? "active" : ""
              }`}
            >
              <Link onClick={(e) => toggleMobileSubmenu("Company", e)} to="#">
                Company
                {/* <i
                  className={`fa fa-chevron-${
                    openMobileSubmenus["Company"] ? "up" : "down"
                  } mobile-submenu-arrow`}
                ></i> */}
              </Link>
              <ul
                className={`submenu ${
                  openMobileSubmenus["Company"] ? "active" : ""
                }`}
                style={{
                  maxHeight: openMobileSubmenus["Company"] ? "1000px" : "0px",
                }}
              >
                <li>
                  <Link onClick={handleNavLinkClick} to="/about">
                    About Us
                  </Link>
                </li>
                {/* <li>
                  <Link onClick={handleNavLinkClick} to="/team">
                    Our Team
                  </Link>
                </li> */}
                <li>
                  <Link onClick={handleNavLinkClick} to="/service">
                    Services
                  </Link>
                </li>
                <li>
                  <Link onClick={handleNavLinkClick} to="/career">
                    Career
                  </Link>
                </li>
                <li>
                  <Link onClick={handleNavLinkClick} to="/technology-partners">
                    Technology Partners
                  </Link>
                </li>
                <li>
                  <Link onClick={handleNavLinkClick} to="/news-articles">
                    News & Articles
                  </Link>
                </li>
                {/* <li>
                  <Link onClick={handleNavLinkClick} to="/contact">
                    Get free consultation
                  </Link>
                </li> */}
               
              </ul>
            </li>
  
            <li
              className={`menu-item-has-children ${
                openMobileSubmenus["Services"] ? "active" : ""
              }`}
            >
              <Link onClick={(e) => toggleMobileSubmenu("Services", e)} to="#">
                Services
                {/* <i
                  className={`fa fa-chevron-${
                    openMobileSubmenus["Services"] ? "up" : "down"
                  } mobile-submenu-arrow`}
                ></i> */}
              </Link>
              <ul
                className={`submenu ${
                  openMobileSubmenus["Services"] ? "active" : ""
                }`}
                style={{
                  maxHeight: openMobileSubmenus["Services"] ? "1000px" : "0px",
                }}
              >
                <li>
                  <Link onClick={handleNavLinkClick} to="/aws-dev">
                    Amazon Web Services (AWS)
                  </Link>
                </li>
                <li>
                  <Link onClick={handleNavLinkClick} to="/office-365">
                    Microsoft 365 (Office 365)
                  </Link>
                </li>
                <li>
                  <Link onClick={handleNavLinkClick} to="/cyber-security">
                    Cyber Security
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link onClick={handleNavLinkClick} to="/blog">
                Blogs
              </Link>
            </li>
            <li>
              <Link onClick={handleNavLinkClick} to="/contact">
               Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
  // ————————————————————————————————————————————————

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-one header-transparent"
    >
      <div
        className={`xb-header stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container-fluid">
          <div className="header__wrap pd-70 ul_li_between">
            <div className="header-logo">
              <Link onClick={handleNavLinkClick} to="/" className="logo01">
                <img src={logo} className="header-logo-img" alt="" />
              </Link>
            </div>

            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li>
                    <Link onClick={handleNavLinkClick} to="/">
                      <span>Home</span>
                    </Link>
                  </li>

                  <li className="menu-item-has-children megamenu">
                    <Link to="#">
                      <span>company</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="megamenu_pages_wrapper mb-5">
                                    <div className="row g-10">
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/about"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon2} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              About Us
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Shaping Tomorrow with Innovation
                                          </span>
                                        </Link>
                                      </div>
{/* 
                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/team"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon4} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Our team
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Experts Behind Your Success.
                                          </span>
                                        </Link>
                                      </div> */}

                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/service"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon5} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Services
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Secure, Scalable IT Solutions
                                          </span>
                                        </Link>
                                      </div>

                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/career"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon8} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              Career
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Grow With Impactful Projects{" "}
                                          </span>
                                        </Link>
                                      </div>

                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/technology-partners"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <Users className="text-primary w-6 h-6" />
                                            </small>
                                            <small className="iconbox_title">
                                              Technology Partners
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Powering Progress Through
                                            Partnerships.
                                          </span>
                                        </Link>
                                      </div>

                                      <div className="col-xl-4 col-md-4">
                                        <Link
                                          onClick={handleNavLinkClick}
                                          className="iconbox_block_2"
                                          to="/news-articles"
                                        >
                                          <span className="icon_title_wrap">
                                            <small className="iconbox_icon">
                                              <img src={icon4} alt="" />
                                            </small>
                                            <small className="iconbox_title">
                                              News & Articles
                                            </small>
                                          </span>
                                          <span className="description mb-0">
                                            Press, features, and updates.
                                          </span>
                                        </Link>
                                      </div>

                                      {/* <div className="col-xl-4 col-md-4">
                                        <ul className="btns_group p-0 unordered_list justify-content-start">
                                          <li>
                                            <Link
                                              onClick={handleNavLinkClick}
                                              to="/contact"
                                              className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-black"
                                            >
                                              Get free consultation
                                            </Link>
                                          </li>
                                        </ul>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>

                  <li className="menu-item-has-children megamenu">
                    <Link to="/service">
                      <span>Services</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
                              <div className="row justify-content-lg-between">
                                <div className="col-xl-12">
                                  <div className="megamenu_widget_inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            <li>
                                              <Link
                                                onClick={() => {
                                                  handleNavLinkClick();
                                                  handleServiceClick("aws");
                                                }}
                                                to="/aws-dev"
                                                className={
                                                  selectedService === "aws"
                                                    ? "active"
                                                    : ""
                                                }
                                              >
                                                <span className="icon_list_text">
                                                  Amazon Web Services (AWS)
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={() => {
                                                  handleNavLinkClick();
                                                  handleServiceClick(
                                                    "microsoft365"
                                                  );
                                                }}
                                                to="/office-365"
                                                className={
                                                  selectedService ===
                                                  "microsoft365"
                                                    ? "active"
                                                    : ""
                                                }
                                              >
                                                <span className="icon_list_text">
                                                  Microsoft 365 (Office 365)
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={() => {
                                                  handleNavLinkClick();
                                                  handleServiceClick(
                                                    "cybersecurity"
                                                  );
                                                }}
                                                to="/cyber-security"
                                                className={
                                                  selectedService ===
                                                  "cybersecurity"
                                                    ? "active"
                                                    : ""
                                                }
                                              >
                                                <span className="icon_list_text">
                                                  Cyber Security
                                                </span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>

                                      <div className="col-xl-6">
                                        <div className="megamenu_widget service-details">
                                          {selectedService === "aws" ? (
                                            <>
                                              <h3
                                                className="pb-2"
                                                style={{ color: "#bd021d" }}
                                              >
                                                Cloud Solutions Built for
                                                Scalability & Security
                                              </h3>
                                              <p>
                                                Empower your business with AWS
                                                cloud services – from migration
                                                and infrastructure setup to
                                                security, compliance, and
                                                optimization.
                                              </p>
                                              <Link
                                                to="/aws-dev"
                                                className="service-cta"
                                              >
                                                Learn More
                                                <span className="btn_icon">
                                                  <svg
                                                    width="13"
                                                    height="13"
                                                    viewBox="0 0 13 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M13 1C13 0.447715 12.5523 2.00008e-07 12 -5.28728e-08L3 7.47917e-07C2.44771 4.10743e-07 2 0.447716 2 1C2 1.55228 2.44772 2 3 2L11 2L11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10L13 1ZM1.70711 12.7071L12.7071 1.70711L11.2929 0.292894L0.292893 11.2929L1.70711 12.7071Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </span>
                                              </Link>
                                            </>
                                          ) : selectedService ===
                                            "microsoft365" ? (
                                            <>
                                              <h3
                                                className="pb-2"
                                                style={{ color: "#bd021d" }}
                                              >
                                                Smart Collaboration for the
                                                Modern Workforce
                                              </h3>
                                              <p>
                                                Boost productivity with
                                                Microsoft 365. From secure
                                                communication tools to
                                                enterprise collaboration and
                                                compliance, we help you get the
                                                most from your Microsoft
                                                ecosystem.
                                              </p>
                                              <Link
                                                to="/office-365"
                                                className="service-cta"
                                              >
                                                Learn More
                                                <span className="btn_icon">
                                                  <svg
                                                    width="13"
                                                    height="13"
                                                    viewBox="0 0 13 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M13 1C13 0.447715 12.5523 2.00008e-07 12 -5.28728e-08L3 7.47917e-07C2.44771 4.10743e-07 2 0.447716 2 1C2 1.55228 2.44772 2 3 2L11 2L11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10L13 1ZM1.70711 12.7071L12.7071 1.70711L11.2929 0.292894L0.292893 11.2929L1.70711 12.7071Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </span>
                                              </Link>
                                            </>
                                          ) : (
                                            <>
                                              <h3
                                                className="pb-2"
                                                style={{ color: "#bd021d" }}
                                              >
                                                Cybersecurity Solutions for a
                                                Resilient Enterprise
                                              </h3>
                                              <p>
                                                Protect your business with
                                                end-to-end cybersecurity
                                                services — from threat detection
                                                and risk management to
                                                compliance, data protection, and
                                                24/7 monitoring.
                                              </p>
                                              <Link
                                                to="/cyber-security"
                                                className="service-cta"
                                              >
                                                Learn More
                                                <span className="btn_icon">
                                                  <svg
                                                    width="13"
                                                    height="13"
                                                    viewBox="0 0 13 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M13 1C13 0.447715 12.5523 2.00008e-07 12 -5.28728e-08L3 7.47917e-07C2.44771 4.10743e-07 2 0.447716 2 1C2 1.55228 2.44772 2 3 2L11 2L11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10L13 1ZM1.70711 12.7071L12.7071 1.70711L11.2929 0.292894L0.292893 11.2929L1.70711 12.7071Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </span>
                                              </Link>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="social_area">
                                    <div className="social_inner ul_li">
                                      <h5>Follow Us:</h5>
                                      <ul className="social_icons_block unordered_list">
                                     <li>
  <a
    href="https://www.facebook.com/SPIOT Systems Private Limitedintel"
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleNavLinkClick}
  >
    <i className="fab fa-facebook-f"></i>
  </a>
</li>

<li>
  <a
    href="https://www.linkedin.com/company/SPIOT Systems Private Limited-intelligence/"
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleNavLinkClick}
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</li>

<li>
  <a
    href="https://x.com/SPIOT Systems Private Limited_intell"
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleNavLinkClick}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6774 7.62177L17.2342 0H15.6805L9.98719 6.61788L5.43998 0H0.195312L7.07159 10.0074L0.195312 18H1.74916L7.76141 11.0113L12.5636 18H17.8083L10.677 7.62177H10.6774ZM8.54921 10.0956L7.8525 9.09906L2.30903 1.16971H4.69564L9.16929 7.56895L9.866 8.56546L15.6812 16.8835H13.2946L8.54921 10.096V10.0956Z"
        fill="#0C111D"
      />
    </svg>
  </a>
</li>

                                      </ul>
                                    </div>
                                    <p className="career_link m-0">
                                      <Link
                                        onClick={handleNavLinkClick}
                                        to="/career"
                                      >
                                        Looking for new career?{" "}
                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link onClick={handleNavLinkClick} to="/blog">
                      <span>Blogs</span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="header-contact d-xl-block">
              <Link
                onClick={handleNavLinkClick}
                to="/contact"
                className="thm-btn thm-btn--header btn-effect_1"
              >
                Let's talk
                <span>
                  <svg
                    width="27"
                    height="23"
                    viewBox="0 0 27 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.9036 0H8.09835C3.6325 0 0 3.63251 0 8.09835V10.2235C0 14.6883 3.6325 18.3208 8.09738 18.3208H8.41206L7.88759 21.1734C7.806 21.6202 8.0022 22.065 8.38876 22.3059C8.56844 22.4176 8.76852 22.473 8.96957 22.473C9.20073 22.473 9.43091 22.3992 9.62614 22.2535L14.8884 18.3218H18.9026C23.3675 18.3218 27 14.6893 27 10.2244V8.09835C27.001 3.63251 23.3685 0 18.9036 0ZM25.2527 10.2225C25.2527 13.7239 22.404 16.5726 18.9026 16.5726H14.598C14.4096 16.5726 14.226 16.6338 14.0745 16.7464L9.90683 19.8603L10.3216 17.6041C10.3682 17.3486 10.2992 17.0864 10.1331 16.8863C9.96705 16.6872 9.72132 16.5716 9.462 16.5716H8.09738C4.59599 16.5716 1.74729 13.7229 1.74729 10.2215V8.09835C1.74729 4.59696 4.59599 1.74826 8.09738 1.74826H18.9026C22.404 1.74826 25.2527 4.59696 25.2527 8.09835V10.2225Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M8.39173 7.75342C7.61473 7.75342 6.98535 8.38279 6.98535 9.15980C6.98535 9.93681 7.61473 10.5662 8.39173 10.5662C9.16874 10.5662 9.79811 9.93681 9.79811 9.15980C9.79714 8.38279 9.16777 7.75342 8.39173 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M13.5006 7.75342C12.7236 7.75342 12.0942 8.38279 12.0942 9.15980C12.0942 9.93681 12.7236 10.5662 13.5006 10.5662C14.2776 10.5662 14.907 9.93681 14.907 9.15980C14.907 8.38279 14.2776 7.75342 13.5006 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M18.6095 7.75342C17.8325 7.75342 17.2031 8.38279 17.2031 9.15980C17.2031 9.93681 17.8325 10.5662 18.6095 10.5662C19.3865 10.5662 20.0159 9.93681 20.0159 9.15980C20.0159 8.38279 19.3865 7.75342 18.6095 7.75342Z"
                      fill="#D44A00"
                    />
                  </svg>
                </span>
              </Link>
            </div>

            <div className="header-bar-mobile d-flex align-items-center d-xl-none">
              {/* <Link
                onClick={handleNavLinkClick}
                to="/contact"
                className="thm-btn thm-btn--header btn-effect_1 d-block header-contact-mobile-btn"
              >
                Let's talk
                <span>
                  <svg
                    width="27"
                    height="23"
                    viewBox="0 0 27 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.9036 0H8.09835C3.6325 0 0 3.63251 0 8.09835V10.2235C0 14.6883 3.6325 18.3208 8.09738 18.3208H8.41206L7.88759 21.1734C7.806 21.6202 8.0022 22.065 8.38876 22.3059C8.56844 22.4176 8.76852 22.473 8.96957 22.473C9.20073 22.473 9.43091 22.3992 9.62614 22.2535L14.8884 18.3218H18.9026C23.3675 18.3218 27 14.6893 27 10.2244V8.09835C27.001 3.63251 23.3685 0 18.9036 0ZM25.2527 10.2225C25.2527 13.7239 22.404 16.5726 18.9026 16.5726H14.598C14.4096 16.5726 14.226 16.6338 14.0745 16.7464L9.90683 19.8603L10.3216 17.6041C10.3682 17.3486 10.2992 17.0864 10.1331 16.8863C9.96705 16.6872 9.72132 16.5716 9.462 16.5716H8.09738C4.59599 16.5716 1.74729 13.7229 1.74729 10.2215V8.09835C1.74729 4.59696 4.59599 1.74826 8.09738 1.74826H18.9026C22.404 1.74826 25.2527 4.59696 25.2527 8.09835V10.2225Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M8.39173 7.75342C7.61473 7.75342 6.98535 8.38279 6.98535 9.15980C6.98535 9.93681 7.61473 10.5662 8.39173 10.5662C9.16874 10.5662 9.79811 9.93681 9.79811 9.15980C9.79714 8.38279 9.16777 7.75342 8.39173 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M13.5006 7.75342C12.7236 7.75342 12.0942 8.38279 12.0942 9.15980C12.0942 9.93681 12.7236 10.5662 13.5006 10.5662C14.2776 10.5662 14.907 9.93681 14.907 9.15980C14.907 8.38279 14.2776 7.75342 13.5006 7.75342Z"
                      fill="#D44A00"
                    />
                    <path
                      d="M18.6095 7.75342C17.8325 7.75342 17.2031 8.38279 17.2031 9.15980C17.2031 9.93681 17.8325 10.5662 18.6095 10.5662C19.3865 10.5662 20.0159 9.93681 20.0159 9.15980C20.0159 8.38279 19.3865 7.75342 18.6095 7.75342Z"
                      fill="#D44A00"
                    />
                  </svg>
                </span>
              </Link> */}
              <button
                type="button"
                className="xb-nav-mobile"
                onClick={() => setSidebarOpen(true)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>
        </div>

        {/* IMPORTANT: Sidebar is rendered ONLY when open, so it can't block scroll or clicks */}
        {sidebarOpen && createPortal(Sidebar, document.body)}
      </div>
    </div>
  );
};

export default Header2;
